import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Madern_1 from '../../../assets/images/home_page_2/modern/01.png';
import Madern_2 from '../../../assets/images/home_page_2/modern/02.png';
import Madern_3 from '../../../assets/images/home_page_2/modern/03.png';

const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

const products = [
    { id: 1, image: Madern_1, name: 'Handle Bottle Tob', price: '$79.00' },
    { id: 2, image: Madern_2, name: 'Handle Bottle Tob', price: '$79.00' },
    { id: 3, image: Madern_3, name: 'Handle Bottle Tob', price: '$79.00' },
    { id: 4, image: Madern_1, name: 'Handle Bottle Tob', price: '$79.00' },
    { id: 5, image: Madern_2, name: 'Handle Bottle Tob', price: '$79.00' },
    { id: 6, image: Madern_3, name: 'Handle Bottle Tob', price: '$79.00' },
];

const Modren = () => {
    return (
        <section id="modern-product" className="modern-product-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-12">
                        <div className="section">
                            <h2 className="section-title cormorant-font">For Modern Home</h2>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                        <div className="section-btn text-start text-lg-end">
                            <Link to="/Shop" title="" className="btn btn-secondary-second">
                                See All Products
                            </Link>
                        </div>
                    </div>
                </div>
                <Slider className="slider modern-product-autoplay" {...settings}>
                    {products.map((product) => (
                        <div key={product.id} className="modern-product-block">
                            <div className="modern-product-img">
                                <Link to="/ShopDetails" title="">
                                    <img src={product.image} className="img-fluid" alt={product.name} />
                                </Link>
                                <div className="modern-product-icons">
                                    <ul>
                                        <li>
                                            <Link to="" title="">
                                                <i className="flaticon-love" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="" title="">
                                                <i className="flaticon-more" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="" title="">
                                                <i className="flaticon-search-interface-symbol" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="modern-product-btn-icon">
                                    <div className="row align-items-center">
                                        <div className="col-lg-3 text-center">
                                            <Link to="#" title="">
                                                <i className="flaticon-love brd-rgt" />
                                            </Link>
                                        </div>
                                        <div className="col-lg-6">
                                            <Link to="#" title="" className="btn btn-primary-two">
                                                Add To Cart
                                            </Link>
                                        </div>
                                        <div className="col-lg-3 text-center">
                                            <Link to="#" title="">
                                                <i className="flaticon-view brd-left" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modern-product-dtl">
                                <h4 className="modern-product-name text-center">
                                    <Link to="/ShopDetails" title="">
                                        {product.name}
                                    </Link>
                                </h4>
                                <p className="modern-product-price text-center">{product.price}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Modren;